import { hash } from './utils/functions';

export default Object.freeze({
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  BASE_URL: process.env.BASE_URL,
  API: {
    URL: process.env.API_URL || '',
    IDENTITY: process.env.API_IDENTITY || '',
    CONNECT: process.env.API_CONNECT || '',
    MONITOR: process.env.API_MONITOR || '',
  },
  ROLLBAR: {
    POST_CLIENT_TOKEN: process.env.ROLLBAR_TOKEN || '',
  },
  GTM: process.env.GTM_CONTAINER_ID || '',
  HASH:
    process.env.NODE_ENV && process.env.NODE_ENV !== 'development' ? hash : '',
});
